/* eslint-disable no-template-curly-in-string */
import { setLocale } from 'yup';

setLocale({
  mixed: {
    notType: 'Valor inválido',
    required: 'Campo obrigatório',
  },
  string: {
    matches: 'Não insira caracteres especiais',
  },
  number: {
    min: 'Deve ser no mínimo ${min}',
    max: 'Deve ser no máximo ${max}',
    integer: 'Somente números inteiros',
  },
});
